import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { InadimplenciaHistoricalOverview } from '@/features/inadimplencia/types/InadimplenciaHistoricalOverview.ts';

async function getTermometroFinanceiroMetricasAlunos(params): Promise<InadimplenciaHistoricalOverview> {
  const api = await getApi();
  const { data } = await api.get<InadimplenciaHistoricalOverview>('/termometro/financeiro/metricas_alunos/', {params});
  return data;
}

type QueryFnType = typeof getTermometroFinanceiroMetricasAlunos;

function useTermometroFinanceiroMetricasAlunos(params) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-termometro-financeiro-metrica-alunos',params ],
    queryFn: () =>  getTermometroFinanceiroMetricasAlunos(params),
  });
}

export { useTermometroFinanceiroMetricasAlunos };
